const initState = {
  successFetching: false,
  errorFetching: false,
  value: 0,
  minMonthlyFee: 0,
  maxMonthlyFee: 0,
};

export default initState;
